<template>
  <div>
    <input type="file" class="vs-inputx vs-input--input normal mb-5" ref="fileInput" @input="onSelectFile" accept="image/jpeg">
    <div v-if="imageData">
      <img :src="imageData" style="width:100%;" />
      <vs-button color="danger" type="filled" style="width:100%;" @click.prevent="deleteImage" class="base-image-input-delete-btn">
        {{ $t('delete_image') }}
      </vs-button>
    </div>

  </div>
</template>

<script>

export default {
  name: 'BaseImageInput',
  data () {
    return {
      imageData: null
    }
  },
  methods: {
    chooseImage () {
      this.$refs.fileInput.click()
    },
    deleteImage () {
      this.$refs.fileInput.value = null
      this.imageData = null
      this.$emit('input', null)
      this.$emit('change', null)
    },
    onSelectFile () {
      const input = this.$refs.fileInput
      const files = input.files
      if (files && files[0]) {
        const reader = new FileReader
        reader.onload = e => {
          this.imageData = e.target.result
        }
        reader.readAsDataURL(files[0])
        this.$emit('input', files[0])
        this.$emit('change', files[0])
      }
    }
  }
}
</script>

<style scoped>
.base-image-input {
  display: block;
  width: 200px;
  height: 200px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
.placeholder {
  background: #F0F0F0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
  font-family: Helvetica;
}
.placeholder:hover {
  background: #E0E0E0;
}
.file-input {
  display: none;
}
</style>
